// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3jzve","unreadBadge":"styles_unreadBadge__2FSPm","modalContent":"styles_modalContent__11Vq3","modal":"styles_modal__8D-ZW"};